function r(t, a, e, n) {
  return Math.sqrt((e - t) ** 2 + (n - a) ** 2);
}
export {
  r as default
};
